export default "__VITE_ASSET__0b419051__"